<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-lg-flex">
                            <div>
                                <h5 class="mb-0">Broadcast Signal</h5>
                                <p class="mb-0 text-sm">
                                    Below the list of Broadcast Signal.
                                </p>
                            </div>
                            <div class="my-auto mt-4 ms-auto mt-lg-0">
                                <div class="my-auto ms-auto">
                                    <a 
                                        href="/broadcast-signal/new"
                                        class="mb-0 btn bg-gradient-success btn-sm me-2"
                                        target="_blank"
                                    >+&nbsp; Add New</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-0 pb-0">
                        <div class="table-responsive">
                            <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                                <div class="dataTable-top">
                                    <div class="dataTable-dropdown">
                                        <label>
                                            <select class="dataTable-selector form-select form-select-sm">
                                                <option value="10">10</option>
                                            </select>
                                            entries per page
                                        </label>
                                    </div>
                                    <div class="dataTable-search">
                                        <input class="dataTable-input" placeholder="Search..." type="text" v-model="search" @change="getAllAPI()">
                                    </div>
                                </div>
                                <div class="dataTable-container">
                                    <table id="signals-list" class="table table-flush dataTable-table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Name</th>
                                                <th>Set Time</th>
                                                <th>Status</th>
                                                <th>Updated At</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(record) in records" :key="record.id">
                                                <td class="text-sm">{{ record.name }}</td>
                                                <td>
                                                    <span class="badge badge-success badge-sm" v-if="record.is_send_now">Send Now</span>
                                                    <span class="badge badge-info badge-sm" v-else>Set Minute</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-danger badge-sm" v-if="record.status == 'declined'">Declined</span>
                                                    <span class="badge badge-danger badge-sm" v-else-if="record.status == 'expired'">Expired</span>
                                                    <span class="badge badge-info badge-sm" v-else-if="record.status == 'pending'">Pending</span>
                                                    <span class="badge badge-warning badge-sm" v-else-if="record.status == 'waiting_confirmation'">Waiting Confirmation</span>
                                                    <span class="badge badge-success badge-sm" v-else-if="record.status == 'active'">Active</span>
                                                </td> 
                                                <td class="text-sm">{{ dateTime(record.updated_at) }}</td>
                                                <td class="text-sm">
                                                    <a :href="`/broadcast-signal/${record.id}/edit`" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Edit Signal">
                                                        <i class="fas fa-edit text-secondary" aria-hidden="true"></i>
                                                    </a>
                                                    <a href="javascript:;" @click="confirmationDelete(record.id)" data-bs-toggle="tooltip" data-bs-original-title="Delete Signal">
                                                        <i class="fas fa-trash text-secondary" aria-hidden="true"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="dataTable-bottom">
                                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                                    <nav class="dataTable-pagination">
                                        <argon-pagination color="success" size="sm">
                                            <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                                            <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                                            <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                                        </argon-pagination>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignalService from "@/services/signal.service.js";
    import ArgonPagination from "@/components/ArgonPagination.vue";
    import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
    import showSwalConfirmationDelete from "@/mixins/showSwal.js";
    import { ref } from 'vue';
    import { toast } from 'vue3-toastify';

    const toastId = ref('');

    const moment = require('moment');

    export default {
        name: "BroadcastSignalList",
        data() {
            return {
                perPages: [5, 10, 15, 20, 25],
                records: [],
                totalRecords: 0,        
                limitPerPage: 5,
                currentPage: 1,
                search: ''
            }
        },
        mixins: [showSwalConfirmationDelete],
        methods: {
            showLoading(){
                toastId.value = toast.loading('Please wait...');
            },
            hideLoading(){
                setTimeout(() => {
                    toast.remove(toastId.value)
                }, 1000); 
            },
            showSuccess(){
                toast.update(toastId.value, {
                    render: "delete Successfully",
                    closeOnClick: true,
                    closeButton: true,
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000
                });      
            },
            showFailed(e){
                toast.update(toastId.value, {
                    render: e,
                    closeOnClick: true,
                    closeButton: true,
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
                });
            },
            confirmationDelete(id){
                this.showSwalConfirmationDelete().then((result) => {
                        console.log(result)
                    if (result.value) {
                        this.deleteRecord(id)
                    }
                });
            },
            deleteRecord(id){
                this.showLoading()

                SignalService.delete(id).then(() => {
                    this.showSuccess()
                    this.getAllAPI()
                }).catch(e => {
                    this.showFailed(e.response.data.code_message)           
                });
            },
            dateTime(value) {
                return moment(value).format("DD MMM YYYY");
            },
            shownData() {
                const total = this.limitPerPage*this.currentPage
                return this.totalRecords > total ? total : this.totalRecords
            },
            dataPerPages() {
                const total = Math.ceil(this.totalRecords / this.limitPerPage)
                return total
            },
            onChangePagination(event) {
                this.currentPage = event
                this.getAllAPI()
            },
            getAllAPI(){
                const params = {
                    limit: this.limitPerPage,
                    page: this.currentPage,
                    filter: this.search
                }
                SignalService.getAll(params).then(e => {
                const data = e.data
                this.records = data.signals
                this.totalRecords = data.count
                })
            }
        },
        components: {
            ArgonPagination,
            ArgonPaginationItem
        },
        mounted() {
            this.getAllAPI()
        },
    }
</script>